var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "list-example" },
    [
      _c("Search", { attrs: { store: _vm.store } }),
      _vm._v(" "),
      _c("Filtr", {
        attrs: { store: _vm.store, name: "SortOrder", label: "Sort By" },
      }),
      _vm._v(" "),
      _c("Filters", { attrs: { store: _vm.store } }),
      _vm._v(" "),
      _c(
        "ol",
        { staticClass: "list-example__items" },
        _vm._l(_vm.items, function (item) {
          return _c(
            "li",
            { key: item.Id, staticClass: "list-example__item" },
            [
              _vm._t(
                "default",
                function () {
                  return [
                    _c("h2", [_vm._v(_vm._s(item.Title))]),
                    _vm._v(" "),
                    _c("p", [_vm._v(_vm._s(item.Description))]),
                  ]
                },
                { item: item }
              ),
            ],
            2
          )
        }),
        0
      ),
      _vm._v(" "),
      _vm.itemsRemaining > 0
        ? _c(
            "button",
            {
              staticClass: "btn btn--full-width",
              attrs: { "data-tsat": "t06-load_more" },
              on: { click: _vm.loadMore },
            },
            [_vm._v(_vm._s(_vm.loadMoreButtonText))]
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }